import { DrawerBody, DrawerHeader } from "@chakra-ui/modal";
import UserForm from "./user-form";
import { useEffect } from "react";
import AtriumApi from "api";
import { useParams } from "react-router-dom";

const EditUser = ({ user, setUser, ...props }) => {
  const { onCancel, onClose } = props;

  const params = useParams();

  // load user in case of navigation by user entering url
  useEffect(() => {
    if (!user?.id) {
      AtriumApi.get(`/v1/users/get-user/${params.id}`).then((resp) => {
        setUser(resp?.data?.user);
      });
    }
  }, []);

  return (
    <>
      <DrawerHeader className="px-[32px] pt-6">
        <div className="font-bold text-xl text-gray-800 dark:text-white">
          Edit user
        </div>
      </DrawerHeader>
      <DrawerBody className="flex-1 px-[32px] my-6 overflow-auto">
        <UserForm
          user={user}
          setUser={setUser}
          onClose={onCancel || onClose}
        ></UserForm>
      </DrawerBody>
    </>
  );
};

export default EditUser;
